import { useState, useCallback } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

const HomePage = () => {
  const [chatOpen, setChatOpen] = useState(false);

  const handleGetQuote = useCallback(() => {
    // Trigger the chat widget to open
    const chatButton = document.querySelector('[data-testid="chat-widget-button"]');
    if (chatButton) {
      chatButton.click();
    }
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen">
      <Navbar onGetQuote={handleGetQuote} />
      <main>
        <HeroSection onGetQuote={handleGetQuote} />
        <ServicesSection onGetQuote={handleGetQuote} />
        <AboutSection />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default HomePage;
